import { baseApi } from './baseApi';

export interface ValidationResponse {
  canOpen?: boolean;
  canClose?: boolean;
  canDelete?: boolean;
  canTransfer?: boolean;
  canCreate?: boolean;
  canModify?: boolean;
  canCancel?: boolean;
  isWithinHours?: boolean;
  tableId?: string;
  fromTableId?: string;
  toTableId?: string;
  areaId?: string;
  productId?: string;
  categoryId?: string;
  orderId?: string;
  currentTime?: string;
}

export interface BusinessRules {
  maxTableCapacity: number;
  maxOrderItems: number;
  minOrderAmount: number;
  isWithinOperatingHours: boolean;
}

export const validationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Table validations
    canOpenTable: builder.query<ValidationResponse, string>({
      query: (tableId) => `/validation/table/${tableId}/can-open`,
    }),
    canCloseTable: builder.query<ValidationResponse, string>({
      query: (tableId) => `/validation/table/${tableId}/can-close`,
    }),
    canDeleteTable: builder.query<ValidationResponse, string>({
      query: (tableId) => `/validation/table/${tableId}/can-delete`,
    }),
    canTransferTable: builder.query<ValidationResponse, { fromTableId: string; toTableId: string }>({
      query: ({ fromTableId, toTableId }) => `/validation/table/${fromTableId}/can-transfer/${toTableId}`,
    }),

    // Area validations
    canDeleteArea: builder.query<ValidationResponse, string>({
      query: (areaId) => `/validation/area/${areaId}/can-delete`,
    }),

    // Product validations
    canDeleteProduct: builder.query<ValidationResponse, string>({
      query: (productId) => `/validation/product/${productId}/can-delete`,
    }),

    // Category validations
    canDeleteCategory: builder.query<ValidationResponse, string>({
      query: (categoryId) => `/validation/category/${categoryId}/can-delete`,
    }),

    // Order validations
    canCreateOrder: builder.query<ValidationResponse, string>({
      query: (tableId) => `/validation/table/${tableId}/can-create-order`,
    }),
    canModifyOrder: builder.query<ValidationResponse, string>({
      query: (orderId) => `/validation/order/${orderId}/can-modify`,
    }),
    canCancelOrder: builder.query<ValidationResponse, string>({
      query: (orderId) => `/validation/order/${orderId}/can-cancel`,
    }),

    // Operating hours
    isWithinOperatingHours: builder.query<ValidationResponse, void>({
      query: () => '/validation/operating-hours',
    }),

    // Business rules
    getBusinessRules: builder.query<BusinessRules, void>({
      query: () => '/validation/business-rules',
    }),
  }),
});

export const {
  // Table validation hooks
  useCanOpenTableQuery,
  useCanCloseTableQuery,
  useCanDeleteTableQuery,
  useCanTransferTableQuery,
  
  // Area validation hooks
  useCanDeleteAreaQuery,
  
  // Product validation hooks
  useCanDeleteProductQuery,
  
  // Category validation hooks
  useCanDeleteCategoryQuery,
  
  // Order validation hooks
  useCanCreateOrderQuery,
  useCanModifyOrderQuery,
  useCanCancelOrderQuery,
  
  // Operating hours hooks
  useIsWithinOperatingHoursQuery,
  
  // Business rules hooks
  useGetBusinessRulesQuery,
} = validationApi;